import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import { Button, Container, Stack, Typography } from '@mui/material';
// components
import { DrawerList } from '../sections/@dashboard/drawer';
// mock
import { useNavigate, useParams } from 'react-router-dom';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import DrawerModal from 'src/components/modal/DrawerModal';
import AddButton from 'src/components/Button.js/AddBotton';
import Loader from 'src/components/loader/loader';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import Iconify from 'src/components/iconify/Iconify';
import CheckingHardware from 'src/components/modal/CheckingHardware';
// ----------------------------------------------------------------------

export default function Drawer() {
    const [visible, setVisible] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [visibleChecking, setVisibleChecking] = useState(false);
    const { t } = useTranslation();
    const params = useParams();
    const getRef = useRef(false);
    const dataLock = useRef({});
    const isEdit = useRef(false);
    const [data, setData] = useState({});
    const success = useRef(false);
    const typeCabinet = useRef();
    const [screenPermissions, setScreenPermissions] = useState({});

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, [success.current]);

    // useEffect(() => {
    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);

    // const handleBeforeUnload = (event) => {
    //     event.preventDefault();
    //     event.returnValue = '';
    // };

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [+params.idPermission, +params.idCabinet];
        sendRequest(serviceList.getAlldrawer, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [success.current]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log("Drawer", message.proc_data.rows)
            setTableData(message.proc_data.rows[0].o_1);
            typeCabinet.current = message.proc_data.rows[0].o_1[0].cabinet_type;
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <Helmet>
                <title> {t('list_drawer')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        {t('list_drawer')}
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<Iconify icon="material-symbols:search-check-rounded" />}
                        onClick={() => setVisibleChecking(true)}
                    >
                        {t('checking_hardware')}
                    </Button>{' '}
                </Stack>
                <Breadcrumb
                    paths={[
                        {
                            label: t('quan_ly_tu'),
                            url: `/home/manager-cabinet/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('list_drawer'), url: '#', navigate: false },
                    ]}
                />

                <Loader loading={getFlags} />
                <DrawerModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    visible={visible}
                    dataUpdate={data}
                    idCabinet={params.idCabinet}
                    fuctGet={getData}
                    setVisible={setVisible}
                    typeCabinet={typeCabinet.current}
                />
                <CheckingHardware
                    dataDrawer={tableData.filter((row) => row?.cells_x > 0)}
                    visible={visibleChecking}
                    setVisible={setVisibleChecking}
                />
                <Stack
                    direction="row"
                    flexWrap="wrap-reverse"
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ mb: 1 }}
                >
                    <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                        {/* <CabinetSort /> */}
                    </Stack>
                </Stack>

                <DrawerList
                    products={tableData}
                    setData={setData}
                    data={dataLock.current}
                    idPermission={params.idPermission}
                    functEdit={() => {
                        isEdit.current = true;
                        setVisible(true);
                    }}
                    getData={getData}
                    screenPermissions={screenPermissions}
                />
            </Container>
            <AddButton
                onClick={() => {
                    isEdit.current = false;
                    setVisible(true);
                    setData({});
                }}
            />
        </>
    );
}
